const quoteTransition = {
    START_RATING : 'start rating',

    CANCEL_RATING_REQUEST : 'cancel rating request',

    COMPLETE_RATING_REQUEST : 'complete rating request',

    GENERATE_RATING : 'generate rating',

    MODIFY_RATING : 'modify rating',

    START_QUOTE : 'start quote',

    GENERATE_QUOTE : 'generate quote',

    MODIFY_QUOTE : 'modify quote',

    SEND : 'send',

    BEGIN_REQUEST_BINDING : 'begin request binding',

    BEGIN_BINDING : 'begin binding',

    REQUEST_BINDING : 'request binding',

    DECLINE_QUOTE : 'decline quote',

    GENERATE_BINDER : 'generate binder',

    MODIFY_BINDER : 'modify binder',

    BIND : 'bind',

    CANCEL_BINDING : 'cancel binding',

    COMPLETE_BINDING : 'complete binding',

    UNBIND : 'unbind',

    DELETE : 'delete',

    WITHDRAW_QUOTE : 'withdraw quote',

    WITHDRAW_REQUEST : 'withdraw request',

    COPY_QUOTE : 'copy quote',

    REPLACE : 'replace',

    START_PRICING : 'start pricing',

    MODIFY_PRICING : 'modify pricing',

    SUBMIT_FOR_ISSUANCE : 'submit for issuance'

};

angular.module('gw-um-j2js')
    .constant('quoteTransition', quoteTransition);